import { useConsentStore } from '../../store/consentStore';

export default function useProtectedQueryEnabled(requested = true) {
  const consentRequired = useConsentStore((state) => state.consentRequired);
  return consentRequired !== true && requested !== false;
}
